"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_datepicker_1 = __importStar(require("react-datepicker"));
const moment_1 = __importDefault(require("moment"));
const fr_1 = require("date-fns/locale/fr");
const en_CA_1 = require("date-fns/locale/en-CA");
var DateState;
(function (DateState) {
    DateState[DateState["START"] = 0] = "START";
    DateState[DateState["END"] = 1] = "END";
})(DateState || (DateState = {}));
class Calendar extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: this.props.startDate
                ? (0, moment_1.default)(this.props.startDate, this.props.dateFormat).valueOf()
                : new Date().getTime(),
            endDate: this.props.endDate
                ? (0, moment_1.default)(this.props.endDate, this.props.dateFormat).hours(23).minutes(59).valueOf()
                : undefined,
            dateState: DateState.START
        };
        this.handleDateChange = this.handleDateChange.bind(this);
        (0, react_datepicker_1.registerLocale)('fr', fr_1.fr); // TODO, make this more generic, when loading locales from date-fns, when need to make conditional import, which is hard to do with webpack in production. Still thinking about a better solution.
        (0, react_datepicker_1.registerLocale)('en', en_CA_1.enCA);
    }
    componentDidUpdate(prevProps, _prevState) {
        if (prevProps.startDate !== this.props.startDate || prevProps.endDate !== this.props.endDate) {
            this.setState({
                startDate: this.props.startDate
                    ? (0, moment_1.default)(this.props.startDate, this.props.dateFormat).valueOf()
                    : new Date().getTime(),
                endDate: this.props.endDate ? (0, moment_1.default)(this.props.endDate, this.props.dateFormat).valueOf() : undefined
            });
        }
    }
    handleDateChange(date) {
        if (date === null) {
            // FIXME Should we reinitialize the date to null? In theory, this widget does not support this.
            console.log('InputCalendar: a null date was set, but we assumed this would be impossible');
        }
        else if (this.state.dateState === DateState.START) {
            const startDate = date.getTime();
            const endDate = !this.state.endDate || this.state.endDate < startDate
                ? new Date(date).setHours(23, 59, 0, 0)
                : this.state.endDate;
            this.setState({
                startDate,
                endDate,
                dateState: DateState.END
            }, () => this.props.onChange(startDate, endDate));
        }
        else {
            const endDate = new Date(date).setHours(23, 59, 0, 0);
            this.setState({
                endDate,
                dateState: DateState.START
            }, () => this.props.onChange(this.state.startDate, endDate));
        }
    }
    _updateDateState(dateState) {
        this.setState({ dateState: dateState });
    }
    render() {
        const inputStyle = { textAlign: 'center', cursor: 'context-menu', width: 'auto' };
        const { startDate, endDate, dateState } = this.state;
        /*for (let i = 0; i < config.languages.length; i++)
    {
      const language = config.languages[i];
      const locale   = config.locales && config.locales[language] ? config.locales[language] : language;
      console.log('lang', language, 'locale', locale);
      registerLocale(language, dateFnsLocales[locale]);
    }*/
        return (react_1.default.createElement("div", { className: "apptr__form-input-container", style: { flexWrap: 'wrap' } },
            react_1.default.createElement("div", { style: { display: 'inline-flex' } },
                react_1.default.createElement("input", { id: `${this.props.id}_startDate`, type: "button", value: (0, moment_1.default)(startDate).format(this.props.dateFormat), onClick: this._updateDateState.bind(this, DateState.START), autoComplete: "off", style: inputStyle }),
                react_1.default.createElement("input", { id: `${this.props.id}_endDate`, type: "button", value: (0, moment_1.default)(endDate).format(this.props.dateFormat), onClick: this._updateDateState.bind(this, DateState.END), autoComplete: "off", style: inputStyle })),
            !this.props.disabled && (react_1.default.createElement("div", { style: { width: '-webkit-fill-available' } },
                react_1.default.createElement(react_datepicker_1.default, { locale: this.props.language, dateFormat: "dd/MM/yyyy", onChange: this.handleDateChange, startDate: new Date(startDate), endDate: endDate ? new Date(endDate) : null, minDate: dateState === DateState.END ? new Date(startDate) : undefined, selectsEnd: dateState === DateState.END ? true : false, openToDate: new Date(startDate), showMonthDropdown: true, showYearDropdown: true, disabledKeyboardNavigation: true, dropdownMode: "select", inline: true })))));
    }
}
Calendar.defaultProps = {
    dateFormat: 'DD-MM-YYYY',
    language: 'en'
};
exports.default = Calendar;
//# sourceMappingURL=Calendar.js.map